import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill';
import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
// import getApp from './get-app'

ReactDOM.render(<App />, document.getElementById('root'));
